import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App error boundary:", error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, fontFamily: "monospace" }}>
          <div style={{ maxWidth: 720 }} data-testid="app-error">
            <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12 }}>Something went wrong.</h2>
            <pre style={{ whiteSpace: "pre-wrap", background: "#111", color: "#f66", padding: 16, borderRadius: 8, fontSize: 12 }}>
              {String(this.state.error?.stack || this.state.error)}
            </pre>
            <button onClick={() => { this.setState({ error: null }); window.location.reload(); }}
              style={{ marginTop: 16, padding: "8px 16px", borderRadius: 999, background: "#E63946", color: "#fff", border: 0 }}>
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
